module.exports = __webpack_public_path__ + "static/media/sausage.f72effb7.svg";